var USER_LOAD_DATA_URL = '/user/default/load-data';
export { USER_LOAD_DATA_URL };